import { fonts, font_variant_styles, palette } from "../../theme"

export const presets = {
  error: `
    font-size: 14px; 
    color: red; 
    font-family: ${fonts.bold};
  `,
  bold: font_variant_styles.p.bold,
  h1: font_variant_styles.h1.bold,
  h2: font_variant_styles.h2.bold,
  h3: font_variant_styles.h3.bold,
  fieldLabel: `font-size: 14px; color: ${palette.Dark_gray};`,
  fieldError: `font-size: 14px; color: red`,
  secondary: `color:  ${palette.Outline_blue};`,
  dim: `font-size: 9px, color: ${palette.dim};`,
  mealCategory: `
    ${font_variant_styles.p.bold} 
    color: ${palette.Orange_crayola};
  `,
  grey: `color: ${palette.Dark_gray};`,
  phoneNumber: `
    ${font_variant_styles.p.bold}
    color: ${palette.Secondary_blue};`,
  stickyNote: `
    ${font_variant_styles.stickyNote.regular}
  `,
}

/**
 * A list of preset names.
 */
export type TextPresets = keyof typeof presets
